import packageJson from '../package.json';

const { version: REACT_APP_HUB_VERSION } = packageJson;

declare global {
  interface Window {
    env: any;
  }
}

type EnvType = {
  REACT_APP_HUB_VERSION: string;

  REACT_APP_LOG_LEVEL: string;

  // API URLs
  REACT_APP_API_URL: string;
  /**
   * API URL handed to UE in the init message. UE calls it from the streaming
   * host, so it can never be the hub's own `localhost`; a local run points this
   * at a deployed backend. Unset everywhere else, where the hub's own API URL
   * is already reachable from UE.
   */
  REACT_APP_UE_API_URL?: string;
  REACT_APP_SPATIAL_MANAGER_WEB_SOCKET_URL: string;
  REACT_APP_AI_API_URL?: string;

  // Environment flags
  REACT_APP_MYTAVERSE_ENV: string;
  SKIP_PREFLIGHT_CHECK?: string;
  DISABLE_ESLINT_PLUGIN?: string;
  NODE_ENV?: string;
  PUBLIC_URL: string;

  // URLs and Links
  REACT_APP_READY_PLAYER_ME: string;
  REACT_APP_SOULMACHINES_API_KEY?: string;
  REACT_APP_HAIRSTYLES_URL?: string;

  // Sentry Configuration
  REACT_APP_SENTRY_DSN: string;
  REACT_APP_SENTRY_ENV: string;
  REACT_APP_SENTRY_REPLAY_SESSION_RATE: string;
  REACT_APP_SENTRY_REPLAY_ERROR_RATE: string;
  REACT_APP_SENTRY_REPLAY_MASK_MEDIA: string;

  // AWS Cognito Configuration
  REACT_APP_COGNITO_CLIENT_ID: string;
  REACT_APP_COGNITO_USERPOOL_ID: string;
  REACT_APP_COGNITO_DOMAIN: string;
  REACT_APP_COGNITO_REDIRECT_URL?: string;

  // Timeout Settings
  REACT_APP_CHAT_AUTO_CLOSE_TIMEOUT_SECONDS: string;
  REACT_APP_GAMELIFT_STREAMS_CONNECTION_TIMEOUT_SECONDS: string;

  REACT_APP_UE_INITIALIZATION_TIMEOUT_SECONDS: string;
  REACT_APP_GAMELIFT_STREAMS_SESSION_STATUS_CHECK_TIMEOUT_SECONDS: string;

  // Map Configuration
  REACT_APP_SINGLE_PLAYER_MAP?: string;
  REACT_APP_MULTI_PLAYER_OFFICE_MAP?: string;
  REACT_APP_MULTI_PLAYER_MAP?: string;
  REACT_APP_MULTI_PLAYER_SANDBOX_MAP?: string;
  REACT_APP_MULTI_PLAYER_TAG?: string;
  REACT_APP_EXTERNAL_EVENT_TAG?: string;

  // Speed Check Configuration
  REACT_APP_SPEED_CHECK_TIMEOUT_SECONDS_GAME?: string;
  REACT_APP_SPEED_CHECK_TIMEOUT_SECONDS_DEVICE_TEST?: string;
  REACT_APP_MIN_SPEED_THRESHOLD_MBPS?: string;
  REACT_APP_MIN_WEBRTC_SPEED_THRESHOLD_MBPS?: string;
  REACT_APP_SPEED_CHECK_MAX_LATENCY?: string;

  // UI Configuration
  REACT_APP_PAGE_TITLE?: string;
  REACT_APP_FAVICON_PATH?: string;
  REACT_APP_LOGO_PATH?: string;
  REACT_APP_SHOW_LEFT_BAR?: string;
  REACT_APP_SHOW_ADMIN_TOOLS?: string;
  REACT_APP_SHOW_PROFILE?: string;
  REACT_APP_SHOW_PRIVATE_CHAT?: string;
  REACT_APP_SHOW_MUTE_ALL_IN_CONFERENCE?: string;
  REACT_APP_VIEW_TOGGLE_EVENT_TAG?: string;

  // Calendar Configuration
  REACT_APP_BOOKING_CALENDER_PAGE_SIZE?: string;

  REACT_APP_DISABLE_DEVELOPERS_TERMINAL?: string;

  REACT_APP_RENEW_AVATAR_TIMEOUT_MINS?: string;
  REACT_APP_MAX_NUMBER_OF_AVATARS?: string;
  REACT_APP_EVENT_CAROUSEL_HIDE_EXTERNAL_EVENT_TAGS?: string;
  REACT_APP_TMS_CLASS_ROOMS_TAG?: string;

  // Event Carousel
  REACT_APP_MAX_CHARS_EVENT_NAME?: string;

  // Features
  REACT_APP_FEATURE_AVATURN?: string;
  REACT_APP_FEATURE_READY_PLAY_ME?: string;
  REACT_APP_FEATURE_AVATARS_CUSTOM?: string;
  REACT_APP_FEATURE_EVENT_SCHEDULER?: string;
  REACT_APP_FEATURE_THIRD_PARTY_COMMUNICATIONS_PROVIDER?: string;
  REACT_APP_FEATURE_THIRD_PARTY_CHAT_PROVIDER?: string;
  REACT_APP_FEATURE_SERVER_LATENCY?: string;
  REACT_APP_FEATURE_SHOW_LANGUAGE?: string;
  REACT_APP_FEATURE_SPATIAL_AUDIO?: string;
  REACT_APP_FEATURE_REPORT_IT?: string;
  REACT_APP_FEATURE_NATIVE_PIXEL_STREAMING?: string;
  // Tags
  REACT_APP_FULL_TIME_EVENT_TAGS?: string;
  REACT_APP_ALWAYS_ON_EVENT_TAGS?: string;
  REACT_APP_SCHEDULED_EVENT_TAGS?: string;
  REACT_APP_CLASSROOM_EVENT_TAGS?: string;
  REACT_APP_BASE_CLASSROOM_EVENT_TAGS?: string;
  REACT_APP_MANDATORY_EVENT_TAG?: string;

  REACT_APP_APP_THEME_HOST_NAME?: string;

  REACT_APP_ENABLE_ASSISTANT_ON_EVENTS_PAGE?: string;
};

export const env: EnvType = {
  REACT_APP_HUB_VERSION,
  ...process.env,
  ...window.env,
};
